import { render } from "./partenaireVue.vue?vue&type=template&id=4d93143b"
import script from "./partenaireVue.vue?vue&type=script&lang=js"
export * from "./partenaireVue.vue?vue&type=script&lang=js"

import "../assets/css/partenaire.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__